import { createSlice } from "@reduxjs/toolkit";
import { showDictionary, getMultiLang } from "../actions";

const initialState = {
  dictionary: [],
  multiLang: [],
};

const dictionarySlice = createSlice({
  name: "dictionary",
  initialState,
  reducers: {},
  extraReducers: {
    [showDictionary.fulfilled]: (state, action) => {
      state.dictionary = action.payload || [];
    },
    [getMultiLang.fulfilled]: (state, action) => {
      state.multiLang = action.payload || [];
    },
  },
});

export const responseDictionary = (state) => state.dictionary;

export default dictionarySlice.reducer;
